import i18n from '../i18n';

// POLICY
export const POLICY_UPDATE_SUCCESS = () => `Successfully saved`;
export const POLICY_UPDATE_FAILURE = () => `Failed to save`;
export const POLICY_AUTOFILL_UPDATE_SUCCESS = () =>
	`Successfully saved & ran autofills`;
export const POLICY_AUTOFILL_UPDATE_FAILURE = () =>
	`Failed to save & run autofills`;
export const POLICY_DISCARD_SUCCESS = () => `Successfully discarded policy`;
export const POLICY_DISCARD_FAILURE = () => `Failed to discard policy`;
export const POLICY_QUOTE_NO_NAME_CREATE = () =>
	`Please enter quote name before creating a new quote`;
export const POLICY_QUOTE_NO_NAME_LOCK = () =>
	`Please enter quote name before locking this quote`;
export const POLICY_QUOTE_NO_NAME_ISSUE = () =>
	`Please enter quote name before issuing this quote`;
export const POLICY_QUOTE_NO_NAME_ACCEPT = () =>
	`Please enter quote name before accepting this quote`;
export const POLICY_QUOTE_SUCCESS = () => `Successfully quoted`;
export const POLICY_QUOTE_FAILURE = () => `Failed to quote`;
export const POLICY_QUOTE_CREATE_SUCCESS = () =>
	`Successfully created new quote`;
export const POLICY_QUOTE_CREATE_FAILURE = () => `Failed to create new quote`;
export const POLICY_QUOTE_DISCARD_SUCCESS = () =>
	`Successfully discarded quote`;
export const POLICY_QUOTE_DISCARD_FAILURE = () => `Failed to discard quote`;
export const POLICY_QUOTE_ISSUE_SUCCESS = () => `Successfully issued policy`;
export const POLICY_QUOTE_ISSUE_FAILURE = () => `Failed to issue policy`;
export const POLICY_QUOTE_ACCEPT_SUCCESS = () => `Successfully accepted quote`;
export const POLICY_QUOTE_ACCEPT_FAILURE = () => `Failed to accept quote`;

// ENDORSEMENTS
export const ENDORSEMENT_CREATE_FAILURE = () =>
	`Failed to create ${i18n.t('endorsement.singular.lower')}`;
export const ENDORSEMENT_UPDATE_SUCCESS = () =>
	`Successfully updated ${i18n.t('endorsement.singular.lower')}`;
export const ENDORSEMENT_AUTOFILL_UPDATE_SUCCESS = () =>
	`Successfully updated ${i18n.t(
		'endorsement.singular.lower',
	)} & ran autofills`;
export const ENDORSEMENT_SAVE_TEXT = () => 'Save';
export const ENDORSEMENT_UPDATE_FAILURE = () =>
	`Failed to update ${i18n.t('endorsement.singular.lower')}`;
export const ENDORSEMENT_AUTOFILL_UPDATE_FAILURE = () =>
	`Failed to update ${i18n.t('endorsement.singular.lower')} & run autofills`;
export const ENDORSEMENT_QUOTE_SUCCESS = () =>
	`Successfully quoted ${i18n.t('endorsement.singular.lower')}`;
export const ENDORSEMENT_QUOTE_FAILURE = () =>
	`Failed to quote ${i18n.t('endorsement.singular.lower')}`;
export const ENDORSEMENT_ACCEPT_SUCCESS = () =>
	`Successfully accepted ${i18n.t('endorsement.singular.lower')}`;
export const ENDORSEMENT_ACCEPT_FAILURE = () =>
	`Failed to accept ${i18n.t('endorsement.singular.lower')}`;
export const ENDORSEMENT_ISSUE_SUCCESS = () =>
	`Successfully issued ${i18n.t('endorsement.singular.lower')}`;
export const ENDORSEMENT_ISSUE_FAILURE = () =>
	`Failed to issue ${i18n.t('endorsement.singular.lower')}`;
export const ENDORSEMENT_INVALIDATE_SUCCESS = () =>
	`Successfully invalidated ${i18n.t('endorsement.singular.lower')}`;
export const ENDORSEMENT_INVALIDATE_FAILURE = () =>
	`Failed to invalidate ${i18n.t('endorsement.singular.lower')}`;
export const ENDORSEMENT_DISCARD_SUCCESS = () =>
	`Successfully discarded ${i18n.t('endorsement.singular.lower')}`;
export const ENDORSEMENT_DISCARD_FAILURE = () =>
	`Failed to discard ${i18n.t('endorsement.singular.lower')}`;
export const LOAD_ENDORSEMENT_FAILURE = () =>
	`Unable to load ${i18n.t('endorsement.singular.lower')} data`;
export const FETCH_ENDORSEMENT_FAILURE = () =>
	`Failed to fetch ${i18n.t('endorsement.singular.lower')} data`;

export const QUOTE_ENDORSEMENT_LABEL = () =>
	`Quote ${i18n.t('endorsement.singular.upper')}`;
export const QUOTE_ENDORSEMENT_MSG = () =>
	`Are you sure you want to quote this ${i18n.t(
		'endorsement.singular.lower',
	)}?`;
export const ACCEPT_ENDORSEMENT_LABEL = () =>
	`Accept ${i18n.t('endorsement.singular.upper')}`;
export const ACCEPT_ENDORSEMENT_MSG = () =>
	`Are you sure you want to accept this ${i18n.t(
		'endorsement.singular.lower',
	)}?`;
export const ACCEPT_ENDORSEMENT_CONFLICT_MSG = (action: string) =>
	`Accepting this endorsement ${action} invalidate all other non-issued quotes.`;
export const ISSUE_ENDORSEMENT_LABEL = () =>
	`Issue ${i18n.t('endorsement.singular.upper')}`;
export const ISSUE_ENDORSEMENT_MSG = () =>
	`Are you sure you want to issue this ${i18n.t(
		'endorsement.singular.lower',
	)}?`;
export const INVALIDATE_ENDORSEMENT_LABEL = () =>
	`Invalidate ${i18n.t('endorsement.singular.upper')}`;
export const INVALIDATE_ENDORSEMENT_MSG = () =>
	`Are you sure you want to invalidate this ${i18n.t(
		'endorsement.singular.lower',
	)}?`;
export const INVALIDATE_ENDORSEMENT_CONFLICT_MSG = (action: string) =>
	`Invalidating this endorsement ${action} also invalidate all other non-issued quotes.`;
export const DISCARD_ENDORSEMENT_LABEL = () =>
	`Discard ${i18n.t('endorsement.singular.upper')}`;
export const CLONE_ENDORSEMENT_LABEL = () =>
	`Clone ${i18n.t('endorsement.singular.upper')}`;
export const CLONE_ENDORSEMENT_UNSAVED_CHANGES_MSG = () =>
	'You are attempting to clone an endorsement which has unsaved changes. These changes will not be included in the new endorsement application. Are you sure you want to proceed?';
export const CLONE_ENDORSEMENT_UNSAVED_CHANGES_CONFIRM_TEXT = () =>
	`Clone ${i18n.t('endorsement.singular.upper')}`;
export const CLONE_ENDORSEMENT_UNSAVED_CHANGES_CANCEL_TEXT = () => 'Cancel';
export const DISCARD_ENDORSEMENT_MSG = () =>
	`Are you sure you want to discard this ${i18n.t(
		'endorsement.singular.lower',
	)}?`;
export const ENDORSEMENT_REVIEW_CHANGES_UNSAVED_CHANGES_MSG = () =>
	'You have unsaved changes. Save your changes to view accurate details.';
export const ENDORSEMENT_CLONE_FAILURE = () =>
	`Failed to clone ${i18n.t('endorsement.singular.lower')}`;
export const ENDORSEMENT_CLONE_CONFLICT_FAILURE = () =>
	`The cloned ${i18n.t(
		'endorsement.singular.lower',
	)} conflicts with the current state of the policy. Please create a new ${i18n.t(
		'endorsement.singular.lower',
	)}.`;
export const ENDORSEMENT_CLONE_CONFLICT_UNKNOWN_FAILURE = () =>
	`Failed to clone, please create a new ${i18n.t(
		'endorsement.singular.lower',
	)}.`;
export const ENDORSEMENT_CLONE_SUCCESS = () =>
	`Successfully cloned ${i18n.t('endorsement.singular.lower')}`;

export const ENDORSEMENT_NEW_POLICY_END_DATE_WARNING_MSG = () =>
	'Changing the Policy Date is a premium-bearing event.';

// RENEWALS
export const RENEWAL_CREATE_FAILURE = () => `Failed to create renewal`;
export const RENEWAL_UPDATE_SUCCESS = () => `Successfully updated renewal`;
export const RENEWAL_AUTOFILL_UPDATE_SUCCESS = () =>
	`Successfully updated renewal & ran autofills`;
export const RENEWAL_UPDATE_FAILURE = () => `Failed to update renewal`;
export const RENEWAL_AUTOFILL_UPDATE_FAILURE = () =>
	`Failed to update renewal & run autofills`;
export const RENEWAL_QUOTE_SUCCESS = () => `Successfully quoted renewal`;
export const RENEWAL_QUOTE_FAILURE = () => `Failed to quote renewal`;
export const RENEWAL_ACCEPT_SUCCESS = () => `Successfully accepted renewal`;
export const RENEWAL_ACCEPT_FAILURE = () => `Failed to accept renewal`;
export const RENEWAL_ISSUE_SUCCESS = () => `Successfully issued renewal`;
export const RENEWAL_ISSUE_FAILURE = () => `Failed to issue renewal`;
export const RENEWAL_INVALIDATE_SUCCESS = () =>
	`Successfully invalidated renewal`;
export const RENEWAL_INVALIDATE_FAILURE = () => `Failed to invalidate renewal`;
export const RENEWAL_DISCARD_SUCCESS = () => `Successfully discarded renewal`;
export const RENEWAL_DISCARD_FAILURE = () => `Failed to discard renewal`;
export const LOAD_RENEWAL_FAILURE = () => `Unable to load renewal data`;
export const FETCH_RENEWAL_FAILURE = () => `Failed to fetch renewal data`;

export const QUOTE_RENEWAL_LABEL = () => `Quote Renewal`;
export const QUOTE_RENEWAL_MSG = () =>
	`Are you sure you want to quote this renewal?`;
export const ACCEPT_RENEWAL_LABEL = () => `Accept Renewal`;
export const ACCEPT_RENEWAL_MSG = () =>
	`Are you sure you want to accept this renewal?`;
export const ACCEPT_RENEWAL_CONFLICT_MSG = (action: string) =>
	`Accepting this renewal ${action} invalidate all other non-issued quotes.`;
export const ISSUE_RENEWAL_LABEL = () => `Issue Renewal`;
export const ISSUE_RENEWAL_MSG = () =>
	`Are you sure you want to issue this renewal?`;
export const INVALIDATE_RENEWAL_LABEL = () => `Invalidate Renewal`;
export const INVALIDATE_RENEWAL_CONFLICT_MSG = (action: string) =>
	`Invalidating this renewal ${action} also invalidate all other non-issued quotes.`;
export const INVALIDATE_RENEWAL_MSG = () =>
	`Are you sure you want to invalidate this renewal?`;
export const CLONE_RENEWAL_LABEL = () =>
	`Clone ${i18n.t('renewal.singular.upper')}`;
export const CLONE_RENEWAL_UNSAVED_CHANGES_MSG = () =>
	'You are attempting to clone a renewal which has unsaved changes. These changes will not be included in the new renewal application. Are you sure you want to proceed?';
export const CLONE_RENEWAL_UNSAVED_CHANGES_CONFIRM_TEXT = () =>
	`Clone ${i18n.t('renewal.singular.upper')}`;
export const CLONE_RENEWAL_UNSAVED_CHANGES_CANCEL_TEXT = () => 'Cancel';
export const RENEWAL_CLONE_FAILURE = () =>
	`Failed to clone ${i18n.t('renewal.singular.lower')}`;
export const RENEWAL_CLONE_CONFLICT_FAILURE = () =>
	`The cloned renewal conflicts with the current state of the policy. Please create a new renewal.`;
export const RENEWAL_CLONE_CONFLICT_UNKNOWN_FAILURE = () =>
	`Failed to clone, please create a new renewal.`;
export const RENEWAL_CLONE_SUCCESS = () =>
	`Successfully cloned ${i18n.t('renewal.singular.lower')}`;
export const DISCARD_RENEWAL_LABEL = () => `Discard Renewal`;
export const DISCARD_RENEWAL_MSG = () =>
	`Are you sure you want to discard this renewal?`;
export const RENEWAL_REVIEW_CHANGES_UNSAVED_CHANGES_MSG = () =>
	'You have unsaved changes. Save your changes to view accurate details.';
export const PROCEED_MSG = () => `Do you want to proceed?`;

// PERILS
export const REMOVE_PERIL_FAILURE = () =>
	`Failed to remove ${i18n.t('peril.singular.lower')}`;

// POLICIES
export const POLICY_ACTION_CHANGE_PAYMENT_PLAN_DROPDOWN_BUTTON_LABEL = () =>
	'Change Payment Schedule';
export const POLICY_ACTION_CHANGE_PAYMENT_PLAN_DIALOG_TITLE = () =>
	'Change Payment Schedule';
export const PRICE_PREVIEW_CHANGES_TABLE_SUMMARY_TITLE = () => 'Summary';
export const PRICE_PREVIEW_CHANGE_TABLE_HEADER = () => 'Change';
export const PRICE_PREVIEW_CHANGES_TABLE_FEES_TITLE = () => 'Fees';
export const PRICE_PREVIEW_FEE_DISPLAY_LABEL = (index: number) =>
	`Fee ${index}`;
export const PRICE_PREVIEW_CHANGES_TABLE_TAXES_TITLE = () => 'Taxes';
export const PRICE_PREVIEW_TAX_DISPLAY_LABEL = (index: number) =>
	`Tax ${index}`;
export const PRICE_PREVIEW_CHANGES_TABLE_HOLDBACKS_TITLE = () => 'Holdbacks';
export const PRICE_PREVIEW_CHANGES_TABLE_COMMISSIONS_TITLE = () =>
	'Commissions';
export const PRICE_PREVIEW_CHANGES_TABLE_COMMISSION_HOLDBACKS_TITLE = () =>
	'Commission Holdbacks';
export const PRICE_PREVIEW_UNSAVED_CHANGES_MSG = () =>
	'You have unsaved changes. Please save your changes to view accurate pricing.';
export const PRICE_PREVIEW_CHANGES_TABLE_NEW_EXPOSURE_LABEL = () => '(Added)';
export const PRICE_PREVIEW_GROSS_PREMIUM_LABEL = () => 'Gross Premium';
export const PRICE_PREVIEW_TECHNICAL_PREMIUM_LABEL = () => 'Technical Premium';
export const PRICE_PREVIEW_PREMIUM_LABEL = () => 'Premium';
export const PRICE_PREVIEW_TOTAL_DUE_LABEL = () => 'Total Due';
export const PRICE_PREVIEW_TOTAL_COMMISSIONS_LABEL = () => 'Total Commissions';
export const PRICE_PREVIEW_TOTAL_FEES_LABEL = () => 'Total Fees';
export const PRICE_PREVIEW_TOTAL_TAXES_LABEL = () => 'Total Taxes';

// SUBCLAIMS
export const ADD_PAYABLE_MODAL_HEADING_TEXT = () => 'Add a payable';
export const ADD_PAYABLE_MODAL_ADD_PAYABLE_ACTION_TEXT = () => 'Add Payable';
export const ADD_PAYABLE_MODAL_CANCEL_ACTION_TEXT = () => 'Cancel';
export const ADD_PAYABLE_MODAL_AMOUNT_MUST_BE_VALID_NUMBER_HELPER_TEXT = () =>
	'Amount must be valid number.';
export const ADD_PAYABLE_MODAL_AMOUNT_MAY_NOT_BE_NEGATIVE_HELPER_TEXT = () =>
	'Amount may  not be negative.';
export const ADD_PAYABLE_MODAL_AMOUNT_LESS_THAN_AVAILABLE_RESERVE_HELPER_TEXT =
	() => 'Amount must be less than available reserve.';
export const ADD_PAYABLE_MODAL_SUCCESS_TOAST_MSG = () =>
	'Successfully created payable';
export const ADD_PAYABLE_MODAL_ERROR_TOAST_MSG = () =>
	'Failed to create payable';
export const ADD_SUBCLAIM_VIEW_LOSS_RESERVE_LABEL = () => 'Loss Reserve';
export const ADD_SUBCLAIM_VIEW_LOSS_RESERVE_TOOLTIP_MESSAGE = () =>
	'Loss reserve cannot be set because there is no coverage at the specified incident date.';
export const ADD_SUBCLAIM_VIEW_EXPENSE_RESERVE_LABEL = () => 'Expense Reserve';
export const ADD_SUBCLAIM_VIEW_NO_EXPOSURE_COVERAGE_WARNING_MESSAGE = () =>
	'This exposure has no coverage during the specified incident date.';
export const ADD_SUBCLAIM_VIEW_NO_LOSS_RESERVE_WARNING_MESSAGE = () =>
	'Displaying information for period :start - :end. No loss reserves can be set.';
export const PAYABLE_DETAILS_HEADER = () => 'Payable';
export const PAYABLE_DETAILS_REVERSE_ACTION = () => 'Reverse Payable';
export const PAYABLE_DETAILS_REVERSE_CONFIRMATION_MSG = () =>
	'Are you sure you want to reverse this payable?';
export const PAYABLE_DETAILS_CLOSE_ACTION = () => 'Close';
export const PAYABLE_DETAILS_CANCEL_ACTION = () => 'Cancel';
export const PAYABLE_DETAIL_REVERSED_LINK_TEXT = () => 'This payable is';

// UNDERWRITING DECISIONS:
export const UNDERWRITING_DECISIONS_TITLE = (decision: string) =>
	`Underwriting Decision - ${decision}`;
export const UNDERWRITING_DECISIONS_NOTES_TITLE = () => 'Notes';
export const UNDERWRITING_DECISIONS_NO_NOTES = () => 'N/A';

// NEW APPLICATIONS:
export const NEW_APPLICATION_BILLING_TYPE = () => 'Select Billing Type';
export const NEW_APPLICATION_CURRENCY_TYPE = () => 'Select Currency';
export const NEW_APPLICATION_PRODUCT_TYPE = () => 'Select Product';
export const NEW_APPLICATION_PAGE_TITLE = () => 'Start New Application';
export const NEW_APPLICATION_FAIL_TOAST = () => 'Failed to create policy.';

// CLAIMS
export const CLAIMS_TABLE_HEADER_ID = () => 'Claim ID';
export const CLAIMS_TABLE_HEADER_CREATED_DATE = () => 'Date Created';
export const CLAIMS_TABLE_HEADER_UPDATED_DATE = () => 'Last Updated';
export const CLAIMS_TABLE_HEADER_INCIDENT_DATE = () => 'Incident Date';
export const CLAIMS_TABLE_HEADER_NOTIFICATION_DATE = () => 'Notification Date';
export const CLAIMS_TABLE_HEADER_STATUS = () => 'Current Status';
export const CLAIM_UPDATED_SUCCESS_TOAST_MSG = () =>
	'Claim updated successfully';
export const CLAIM_UPDATED_FAILURE_TOAST_MSG = () => 'Failed to update claim';
export const CLAIM_CLOSED_SUCCESS_TOAST_MSG = () => 'Claim closed successfully';
export const CLAIM_CLOSED_FAILURE_TOAST_MSG = () => 'Failed to close claim';
export const CLAIM_REOPEN_SUCCESS_TOAST_MSG = () =>
	'Claim reopened successfully';
export const CLAIM_REOPEN_FAILURE_TOAST_MSG = () => 'Failed to reopen claim';
export const CLAIM_OPEN_SUCCESS_TOAST_MSG = () => 'Claim opened successfully';
export const CLAIM_OPEN_FAILURE_TOAST_MSG = () => 'Failed to open claim';
export const CLAIM_DISCARDED_SUCCESS_TOAST_MSG = () =>
	'Claim discarded successfully';
export const CLAIM_DISCARDED_FAILURE_TOAST_MSG = () =>
	'Failed to discarded claim';
export const CLAIM_SAVE_BUTTON_TEXT = () => 'Save';
export const CLAIM_CANCEL_BUTTON_TEXT = () => 'Cancel';
export const CLAIM_EDIT_BUTTON_TEXT = () => 'Edit Claim';
export const CLAIM_CLOSE_BUTTON_TEXT = () => 'Close Claim';
export const CLAIM_REOPEN_BUTTON_TEXT = () => 'Reopen Claim';
export const CLAIM_DISCARD_BUTTON_TEXT = () => 'Discard Claim';
export const CLAIM_OPEN_BUTTON_TEXT = () => 'Open Claim';
export const LEAVE_PAGE_WARNING_MESSAGE = () =>
	'Leave page before saving changes?';
export const CLAIM_OPEN_MODAL_WARNING_MESSAGE = () =>
	'No coverage is in force at the specified incident date. You can open the claim and add subclaims, but you will not be able to set loss reserves.';
export const CLAIM_OPEN_MODAL_WARNING_TITLE = () =>
	'Are you sure you want to open this claim?';
export const CLAIM_OPEN_MODAL_CONFIRM_ACTION_TEXT = () => 'Ok';
export const CLAIM_OPEN_MODAL_CANCEL_ACTION_TEXT = () => 'Cancel';
export const CLAIM_SAVE_MODAL_NO_COVERAGE_WARNING_TITLE = () =>
	'No coverage in force at specified incident date';
export const CLAIM_SAVE_MODAL_NO_SUBCLAIM_COVERAGE_WARNING_TITLE = () =>
	`No coverage in force for subclaims`;
export const CLAIM_SAVE_MODAL_NO_COVERAGE_WARNING_MSG = () =>
	'You can edit claim details and add subclaims, but you will not be able to set loss reserves.';
export const CLAIM_SAVE_MODAL_SUBCLAIM_WARNING_MSG = () =>
	'The loss reserves on the following subclaims will be set to zero.';
export const CLAIM_SAVE_MODAL_WARNING_CONFIRM_BUTTON = () => 'Confirm';
export const CLAIM_SAVE_MODAL_WARNING_CANCEL_BUTTON = () => 'Cancel';
export const CLAIM_SAVE_MODAL_WARNING_SUBCLAIM = () => 'Subclaim';
export const CLAIM_SAVE_MODAL_WARNING_LOSS_RESERVE = () =>
	'Total Loss Reserve: ';
export const CLAIM_SAVE_MODAL_WARNING_EXPENSE_RESERVE = () =>
	'Total Expense Reserve: ';

// LOGIN
export const LOGIN_WELCOME = () => 'Welcome!';
export const INVALID_LOGIN_MESSAGE = () =>
	'Unable to log in. Verify your information and try again.';
export const INVALID_HOSTNAME_MESSAGE = () =>
	'Tenant hostname is wrong. Verify it and try again.';
export const INVALID_AUTHORIZATION_MESSAGE = () =>
	'You do not meet the minimum required permissions to use this application.';
export const INVALID_AUTHORIZATION_REQUIRED_PERMISSIONS_TITLE_MESSAGE = () =>
	'Please ask your system administrator to grant you the following permissions: ';
export const LOGIN_EMPTY_PASSWORD = () => 'Password is empty';
export const LOGIN_FORGOT_PASSWORD = () => 'Forgot Password?';
export const LOGIN_SSO_INFO = () =>
	'Switch to Single Sign-On (SSO) to skip this step.';
export const LOGIN_SSO_LEARN = () => 'Learn More';
export const LOGIN_CONFIG_MESSAGE = () =>
	'Please log in with your Configuration Studio credentials.';
export const LOGIN_PASSWORD = () => 'Password';
export const LOGIN_PASSWORD_RECOVER = () =>
	'Please contact your system administrator to recover your password.';
export const LOGIN_CLOSE = () => 'Close';
export const LOGIN_STANDARD_LOGIN = () => 'Login';
export const LOGIN_ADMIN_LOGIN = () => 'Administration Login';
export const LOGIN_STANDARD = () => 'Standard';
export const LOGIN_ADMIN = () => 'Administrator Login';
export const LOGIN_EMPTY_USERNAME = () => 'Username is empty';
export const LOGIN_EMPTY_HOSTNAME = () => 'Hostname is empty';
export const LOGIN_SESSION_EXPIRED_TITLE = () => 'Session Expired';
export const LOGIN_SESSION_EXPIRED_TEXT = () =>
	'Your session has expired. Please log in again';
export const LOGIN_SWITCH_TEXT = () => 'Switch To';
export const USERNAME_LABEL = () => 'Username';
export const PASSWORD_LABEL = () => 'Password';
export const EMAIL_LABEL = () => 'Email';
export const CONFIRM_PASSWORD_LABEL = () => 'Confirm Password';
export const HOSTNAME_LABEL = () => 'Tenant Hostname';

// LOGOUT
export const LOGOUT_ACTION_TEXT = () => 'Logout';
export const ENABLE_UI_PREVIEW_TEXT = () => 'Enable UI Preview';
export const DISABLE_UI_PREVIEW_TEXT = () => 'Disable UI Preview';
export const LOGOUT_CONTINUE_ACTION_TEXT = () => 'Continue';
export const LOGOUT_CONFIRM_ACTION_TEXT = () => 'Confirm Logout';
export const LOGOUT_CONFIRM_INFO_TEXT = () =>
	'Are you sure you want to logout?';
// PREMIUM REPORT:
export const PREMIUM_REPORT_UPDATE_SUCCESS = () =>
	'Successfully updated premium report';
export const PREMIUM_REPORT_UPDATE_FAILURE = () =>
	'Failed to update premium report';
export const PREMIUM_REPORT_ISSUE_SUCCESS = () =>
	'Successfully issued premium report';
export const PREMIUM_REPORT_ISSUE_FAILURE = () =>
	'Failed to issue premium report';
export const PREMIUM_REPORT_REPLACE_SUCCESS = () =>
	'Successfully replaced premium report';
export const PREMIUM_REPORT_REPLACE_FAILURE = () =>
	'Failed to replace premium report';
export const PREMIUM_REPORT_UI_UPDATE_FAILURE = () =>
	'Form contains invalid data. Please review the highlighted errors under each input.';

// HEADER:
export const ADD_NEW_APPLICATION_BUTTON_TEXT = () => 'New Application';
export const ADD_NEW_PAYMENT_BUTTON_TEXT = () => 'New Payment';
export const ADD_NEW_POLICYHOLDER_BUTTON_TEXT = () => 'New Policyholder';
export const HEADER_HOME_BUTTON_TEXT = () => 'Home';
export const HEADER_PAYMENTS_BUTTON_TEXT = () => 'Payments';
export const HEADER_REPORTS_BUTTON_TEXT = () => 'Reports';
export const HEADER_CREATE_DROPDOWN_TEXT = () => 'Create';
export const LOGOUT_CONFIRM_MODAL_TITLE = () => 'Confirm Logout';
export const LOGOUT_CONFIRM_MODAL_BODY = () =>
	'Are you sure you want to logout?';
export const LOGOUT_CONFIRM_CANCEL_ACTION_TEXT = () => 'Cancel';
export const CHANGE_PASSWORD_ACTION_TEXT = () => 'Change Password';
export const CHANGE_PASSWORD_CURRENT_LABEL = () => 'Old Password';
export const CHANGE_PASSWORD_NEW_LABEL = () => 'New Password';
export const CHANGE_PASSWORD_SUCCESS = () =>
	'Successfully changed password & logged out';
export const CHANGE_PASSWORD_FAILURE = () => 'Failed to change password';
export const CHANGE_PASSWORD_CONFIRM_ACTION_TEXT = () => 'Update Password';
export const CHANGE_PASSWORD_CANCEL_ACTION_TEXT = () => 'Cancel';
export const CHANGE_PASSWORD_SUBHEADER = () =>
	'You will be logged out after updating your password.';
export const CHANGE_PASSWORD_REPEAT_WARNING = () =>
	'New password must not match old password.';
export const CHANGE_PASSWORD_STRENGTH_LABEL_WEAK = () => `Weak`;
export const CHANGE_PASSWORD_STRENGTH_LABEL_FAIR = () => `Fair`;
export const CHANGE_PASSWORD_STRENGTH_LABEL_GOOD = () => `Good`;
export const CHANGE_PASSWORD_STRENGTH_LABEL_STRONG = () => `Strong`;
export const ACCOUNT_BUTTON_LABEL = () => 'Account';
export const SWITCH_ROLES_BUTTON_LABEL = () => 'Switch Roles and Logout';
export const UI_PREVIEW_CONFIRM_MODAL_TITLE = () => 'Use UI Preview?';
export const UI_PREVIEW_CONFIRM_MODAL_BODY = () =>
	'Enabling this feature will allow you to preview new UI changes before they are released.';
export const UI_PREVIEW_CONFIRM_MODAL_BODY_CONT = () =>
	'This feature is intended for feedback purposes, and will allow you to participate in feedback of new UI elements. You may opt out at any time.';
export const UI_PREVIEW_CONFIRM_CANCEL_ACTION_TEXT = () => 'Cancel';
export const UI_PREVIEW_CONFIRM_ACTION_TEXT = () => 'Enable UI Preview';

export const UI_PREVIEW_DISABLE_CONFIRM_MODAL_TITLE = () =>
	'Disable UI Preview?';
export const UI_PREVIEW_DISABLE_CONFIRM_MODAL_BODY = () =>
	'Disabling this feature will remove the ability to preview new UI changes before they are released. You may opt back in at any time.';
export const UI_PREVIEW_DISABLE_CONFIRM_CANCEL_ACTION_TEXT = () => 'Cancel';
export const UI_PREVIEW_DISABLE_CONFIRM_MODAL_IMAGE_ALT = () =>
	'Policy summary changes';
export const UI_PREVIEW_DISABLE_CONFIRM_ACTION_TEXT = () =>
	'Disable UI Preview';

// DATA AUTOFILL
export const RUN_AUTOFILL = () => 'Run Autofill';
export const RUN_AUTOFILL_CANCEL_BUTTON_TEXT = () => 'Cancel';
export const RUN_AUTOFILL_CONFIRMATION_TITLE = () =>
	'Are you sure you want to run configured Data Autofill sequence(s)?';
export const RUN_AUTOFILL_CONFIRMATION_BODY = () =>
	'This action will save any existing changes and run autofill operations.';

// LAYOUT
export const USERS_TAB_TEXT = () => 'Users';
export const INTEGRATIONS_TAB_TEXT = () => 'Integrations';
export const SCRIPT_LOGS_TAB_TEXT = () => 'Script Logs';
export const TENANTS_DROPDOWN_LABEL = () => 'TENANTS';

// ADMIN ACCOUNT PAGE
export const NAME_LABEL = () => 'Name';
export const TIME_CREATED_LABEL = () => 'Created';
export const PASSWORD_HIDDEN_TEXT = () => '**************';

// ADMIN USERS PAGE
export const ADMIN_ACCOUNT_DETAILS_HEADER = () => 'Account';
export const ADMIN_ACCOUNT_DETAILS_FEATURE_FLAG_SUCCESS_SAVE = () =>
	'Settings saved. Reload to enable changes.';
export const ADMIN_ACCOUNT_DETAILS_SAVE_BUTTON = () => 'Save';
export const ADMIN_ACCOUNT_DETAILS_FEATURE_FLAG_LABEL = () => 'Feature Flags';

// USER PERMISSIONS
export const DEPRECATED__FULL_ACCESS_INTERNAL = () => 'account.tenant.employee';
export const DEPRECATED__READ_ONLY_INTERNAL = () =>
	'account.tenant.read.only.user';
export const DEPRECATED__CLAIMS_ONLY_INTERNAL = () =>
	'account.tenant.claims.only.user';
export const DEPRECATED__FULL_ACCESS_LABEL = () => 'Full Access';
export const DEPRECATED__READ_ONLY_LABEL = () => 'Read Only';
export const DEPRECATED__CLAIMS_ONLY_LABEL = () => 'Claims Only';
// INVOICES
export const WRITE_OFF_INVOICE_SUCCESS = () => 'Successfully wrote off invoice';
export const WRITE_OFF_INVOICE_FAILURE = () => 'Failed to write off invoice';
export const WRITE_OFF_INVOICE_TITLE = () => 'Write Off Invoice?';
export const WRITE_OFF_INVOICE_BUTTON = () => 'Write Off';
export const WRITE_OFF_INVOICE_BODY = (invoiceId: string) =>
	`Are you sure you want to write off Invoice ${invoiceId}?`;
export const WRITE_OFF_INVOICE_CONFIRM = () => 'Yes, Write Off';
export const WRITE_OFF_INVOICE_CANCEL = () => 'Cancel';

export const INVOICE_STATUS_OUTSTANDING = () => 'Outstanding';
export const INVOICE_STATUS_UNFULFILLED = () => 'Unfulfilled';
export const INVOICE_STATUS_WRITTEN_OFF = () => 'Written Off';
export const INVOICE_STATUS_ZERO_DUE = () => 'Zero Due';
export const INVOICE_STATUS_SETTLED = () => 'Settled';
export const INVOICE_STATUS_CARRIED_FORWARD = () => 'Carried Forward';
export const INVOICE_STATUS_PAID = () => 'Paid';
export const INVOICE_STATUS_INVALIDATED = () => 'Invalidated';
export const INVOICE_STATUS_ERROR = () => 'Status Not Found';

export const PAY_INVOICE_SUCCESS = () => 'Successfully paid invoice';
export const PAY_INVOICE_FAILURE = () => 'Failed to pay invoice';
export const REVERSE_INVOICE_SUCCESS = () => 'Successfully reversed payment';
export const REVERSE_INVOICE_FAILURE = () => 'Failed to reverse payment ';

export const FETCH_INVOICE_FAILURE = () => 'Failed to fetch invoice';
export const FETCH_INVOICES_FAILURE = () => 'Failed to fetch invoices';
export const FETCH_UPDATED_INVOICE_FAILURE = () =>
	'Unable to fetch updated invoice data';

// EXPOSURE
export const EXPOSURE_CLONE_LABEL = () => 'Clone';
export const EXPOSURE_CLONE_SUCCESS = () => 'Successfully cloned exposure';
export const EXPOSURE_CLONE_FAILURE = () => 'Failed to clone exposure';

// GRACE PERIOD
export const GRACE_PERIOD_TABLE_LABEL = () => 'Grace Periods';
export const EMPTY_GRACE_PERIOD_TABLE_LABEL = () => 'No Grace Periods';
export const GRACE_PERIOD_INVOICE_LABEL = () => 'Invoice';

// GENERAL
export const NOT_AVAILABLE_LABEL = () => 'N/A';
export const ERROR_HEADER = () => `Uh Oh! We've encountered an issue!`;
export const NON_QUOTES_ERROR_LN1 = () =>
	'This policy is unissued and does not utilize quotes functionality.';
export const NON_QUOTES_ERROR_LN2 = () =>
	'Accessing such a policy is unsupported in this application.';
export const NON_QUOTES_ERROR_LN3 = () =>
	'Please use Legacy UI to issue the policy and then return here to perform further transactions.';

// ROLE SELECT
export const ROLE_SELECT_WELCOME_LABEL = () => 'Welcome!';
export const ROLE_SELECT_SWITCH_LABEL = () => 'Switch To ';
export const ROLE_SELECT_SWITCH_ADMINISTRATION_LABEL = () =>
	'Administrator Login';
export const ROLE_SELECT_SELECT_NAMESPACE_LABEL = () => 'Select a namespace';
export const ROLE_SELECT_SWITCH_AND_LOGOUT_BUTTON_LABEL = () =>
	'Switch Role and Logout';
export const ROLE_SELECT_FIELD_REQUIRED_MESSAGE = () => 'Required';
export const ROLE_SELECT_NAMESPACE_FIELD_LABEL = () => 'Namespace';
export const ROLE_SELECT_TENANT_FIELD_LABEL = () => 'Tenant';

// Search
export const ADVANCED_SEARCH_LABEL = () => 'Advanced Search';
export const ADVANCED_SEARCH_LABEL_2 = () => 'Advanced search';
export const SEARCH_FEATURE_GUIDE = () => 'Search Feature Guide';
export const SEARCH_FILTER_BY_TYPE = () => 'Type';
export const SEARCH_FILTER_BY_PRODUCT = () => 'Product';
export const SEARCH_INCLUDE_REPLACED_DATA = () => 'Include replaced data';
export const SEARCH_BUTTON = () => 'Search';
export const RESET_BUTTON = () => 'Reset';
export const CARD_NAME = () => 'Name:';
export const CARD_AMOUNT = () => 'Amount:';
export const SEARCH_CARD_POLICY_TAG = (policyLocator: string) =>
	` (Policy: ${policyLocator})`;

// Invoices
export const INVOICES_TABLE__PAY_INVOICE_LABEL = () => 'Pay Invoice';
export const INVOICES_TABLE__HEADER = () => 'Invoices';
export const INVOICES_TABLE__NO_INVOICES = () => 'No Invoices';
export const INVOICES_TABLE__INVOICE_ID_HEADER = () => 'Invoice ID';
export const INVOICES_TABLE__INVOICE_TYPE_HEADER = () => 'Type';
export const INVOICES_TABLE__INVOICE_BILLING_PERIOD_HEADER = () =>
	'Billing Period';
export const INVOICES_TABLE__INVOICE_ISSUE_DATE_HEADER = () => 'Date Created';
export const INVOICES_TABLE__INVOICE_DUE_DATE_HEADER = () => 'Due Date';
export const INVOICES_TABLE__INVOICE_TOTAL_DUE_HEADER = () => 'Total';
export const INVOICES_TABLE__INVOICE_STATUS_HEADER = () => 'Status';
export const INVOICES_TABLE__REVERSE_PAYMENT_LABEL = () => 'Reverse Payment';
export const INVOICES_TABLE__WRITE_OFF_LABEL = () => 'Write Off';
export const INVOICES_TABLE__DOWNLOAD_INVOICE_LABEL = () => 'Download Invoice';
export const INVOICES_TABLE__COPY_INVOICE_LABEL = () => 'Copy Invoice Locator';
export const INVOICES_TABLE__COPY_INVOICE_SUCCESS_TOAST = () =>
	'Invoice locator copied to clipboard';

// Breadcrumbs
export const BREADCRUMB__INVOICES = () => 'Invoices';
export const BREADCRUMB__INVOICE = (invoiceId: string) =>
	`Invoice ${invoiceId}`;

// Apply Payments
export const APPLY_PAYMENT_SUCCESS = () => 'Successfully applied payment';
export const APPLY_PAYMENT_FAILURE = () => 'Failed to apply payment';
